module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc3-49a529cc2a68b038e917140fd4904cad.jpg";